import { api } from './request'

// 订单管理API
const orders = {
  // 获取订单列表
  list: (params) => api.get('/admin/orders', { params }),

  // 获取单个订单详情
  get: (id) => api.get(`/admin/orders/${id}`),

  // 更新订单
  update: (id, data) => api.put(`/admin/orders/${id}`, data),

  // 删除订单
  delete: (id) => api.delete(`/admin/orders/${id}`),

  // 确认订单
  confirm: (id) => api.post(`/api/orders/${id}/confirm`),

  // 创建订单（如果需要）
  create: (data) => api.post('/admin/orders', data)
}

export default orders